import React, { useState } from 'react';

import { Form, Grid, Image, Checkbox, Button, Icon, Input, Segment, Modal, Header, Message } from 'semantic-ui-react'
import { saveContainer, searchForMbols, mergeshipmentMbolsToTransaction, saveDutiesNonMerchandise, updateEngineBolTable, deleteFromEngineBolTable } from '../api/setFormData'
import { transformTransactionsForMerge } from '../api/util';
import { useSelector } from 'react-redux';

function SearchBolsModal(allProps) {

    const isTarget = window.location.href.includes("target")
    const ReconInfo = useSelector((state)=> state?.ReconInfo || {});

    const [manifoldSearchResult, setManifoldSearchResult] = useState("");
    const [shipmentsClickedList, setShipmentsClickedList] = useState([]);
    const [failureMergeState, setFailureMergeState] = useState(false);
    const [mergeButtonDisabled, setMergeButtonDisabled] = useState(false);
    const [mergingGoingOn, setMergingGoingOn] = useState(false);
    const [mergingGoingMessage, setMergingGoingMessage] = useState("");
    const [mergeErrors, setMergeErrors] = useState(null);
    const [debounceOfMbolSearch, setDebounceOfMbolSearch] = useState(null);
    const [searchModalOpen, setSearchModalOpen] = useState(false);
    const [localSearchText, setLocalSearchText] = useState("");

    const showSearchPane = (shipmentList) => {
        if ((shipmentList || []).length == 0) {
            return <div>Nothing to see yet, try searching above.</div>
        }
        if (localSearchText && (shipmentList || []).filter(axx => JSON.stringify(axx || "").toUpperCase().includes(localSearchText || "")).length == 0) {
            return <div>No results for '{localSearchText || ""}'</div>

        }
        const {
            isDisabled,
        } = allProps;
        return <>
            Found {(shipmentList || []).length} shipment{(shipmentList || []).length == 1 ? '' : 's'}
            <hr />
            <table style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <td>
                        </td>
                        <td>Shipment</td>
                        <td style={{ minWidth: '100px' }} title="Master Bill of Lading">MBOL</td>
                        <td style={{ minWidth: '100px' }} title="House Bill of Lading">HBOL</td>
                        <td style={{ minWidth: '100px' }} title="Country of Origin">COO</td>
                        <td style={{ minWidth: '100px' }} title="Port of Unlading">DEST</td>
                        <td style={{ minWidth: '100px' }} title="CARRIER ID">CARRIER</td>
                        {/* <td style={{ minWidth: '100px' }} title="Voyage Number">VOYAGE</td> */}
                    </tr>
                </thead>
                <tbody>
                    {(shipmentList || []).filter(axx => JSON.stringify(axx || "").toUpperCase().includes(localSearchText || "")).map(onefoundbol => {
                        return (<tr key={JSON.stringify(onefoundbol)}>
                            <td>
                                {
                                    onefoundbol?.state?.modeOfTransport == "AIR" ? <Icon name="plane" /> :
                                        onefoundbol?.state?.modeOfTransport == "TRUCK" ? <Icon name="truck" /> :
                                            onefoundbol?.state?.modeOfTransport == "RAIL" ? <Icon name="train" /> :
                                                onefoundbol?.state?.modeOfTransport == "OCEAN" ? <Icon name="ship" /> :
                                                    "?"
                                }
                            </td>
                            <td>
                                <Checkbox
                                    className=''
                                    label={onefoundbol?.state?.shipmentId}
                                    disabled={isDisabled || mergeButtonDisabled}
                                    checked={shipmentsClickedList.includes(onefoundbol?.state?.shipmentId)}
                                    onChange={() => {
                                        if (shipmentsClickedList.includes(onefoundbol?.state?.shipmentId)) {
                                            setShipmentsClickedList(shipmentsClickedList.filter(aaaa => aaaa != onefoundbol?.state?.shipmentId));
                                        } else {
                                            setShipmentsClickedList([...shipmentsClickedList, onefoundbol?.state?.shipmentId]);
                                        }
                                    }}
                                /></td>
                            <td style={{ fontWeight: 'bold' }}>{onefoundbol?.state?.mbol}</td>
                            <td style={{ fontWeight: 'bold' }}>{onefoundbol?.state?.hbol}</td>
                            <td style={{ fontWeight: 'bold' }}>{onefoundbol?.state?.countryOfOrigin}</td>
                            <td style={{ fontWeight: 'bold' }}>{onefoundbol?.state?.unlocUnlading}</td>
                            <td style={{ fontWeight: 'bold' }}>{onefoundbol?.state?.carrierName || onefoundbol?.state?.carrierId || onefoundbol?.consolidationMatchUS?.vessel}</td>
                            {/* <td style={{ fontWeight: 'bold' }}>{onefoundbol?.state?.voyageNumber || onefoundbol?.consolidationMatchUS?.voyage}</td> */}


                            <td></td>

                        </tr>)

                    })}
                </tbody>
            </table></>
    }


    const {
        isDisabled,
        customerCode,
        shipmentId,
        entryTypeValues,
        transportationInfo
    } = allProps;
    let propsForSearchForMbols = {
        customerCode: customerCode,
        modeOfTransport: transportationInfo?.modeOfTransport,
        vessel: transportationInfo?.carrierIdOO,
        voyage: transportationInfo?.tripInformation,
        portOfUnlading: transportationInfo?.USportOfUnladingCode?.id,
        importingCarrier: transportationInfo?.importingCarrier
    }
    if(transportationInfo?.modeOfTransport=="MOT_AIR"){
        propsForSearchForMbols.vessel = transportationInfo?.importingCarrier;
        propsForSearchForMbols.voyage = transportationInfo?.flightNo
    }
    return <Modal
        closeIcon
        style={{ width: '90vw' }}
        onClose={() => {
            setSearchModalOpen(false);
            setShipmentsClickedList([]);
            setManifoldSearchResult("");
            setMergeErrors(null);
            if(mergeErrors?.warnings?.length && !mergeErrors?.errorResponse?.errors?.length){
                document.getElementById(`card-${shipmentId}`) && document.getElementById(`card-${shipmentId}`).click();//this would be better as a api call that just reloads the bol table :/
            }
        }}
        onOpen={() => {
            searchForMbols("", propsForSearchForMbols, isTarget, ReconInfo).then(response => {
                if(isTarget){
                    setManifoldSearchResult(transformTransactionsForMerge(response.data.eventMessage))
                } else{
                    setManifoldSearchResult(response.data.eventMessage)
                }
                setMergingGoingMessage("")
                setMergeErrors(null)
            })

            setSearchModalOpen( true )
        }}
        open={searchModalOpen}
        trigger={<Button style={{marginLeft:'13px'}}>
            <Icon name='plus' size="large" color='green' />Search BOLs</Button>}
    >
        <Modal.Header>Select MBOLs and HBOLs to add to transaction</Modal.Header>
        {mergeErrors?.errorResponse?.errors?.length || mergeErrors?.warnings?.length ?  
        <Modal.Actions style={{maxHeight: "25vh", overflow:"scroll"}} >
                    {mergeErrors?.errorResponse?.errors?.length ? 
                <Message color='red' >
                        <ul style={{textAlign:"left"}} >
                            {mergeErrors.errorResponse.errors.map((err)=><li style={{listStyleType: "disc"}}>{err.message}</li>)}
                        </ul>
                </Message>
                        : null
                    }
                    {mergeErrors?.warnings?.length ? 
                <Message color='yellow'>
                        <ul style={{textAlign:"left"}}>
                            {mergeErrors.warnings.map((warn)=><li style={{listStyleType: "disc"}}>{warn}</li>)}
                        </ul>
                </Message>
                : null
            }
            </Modal.Actions>
        : null}
        <Modal.Content style={{ width: '100%' }}>
            <Modal.Description >
                {/* <Header>Default Profile Image</Header> */}
                <Input

                    disabled={isDisabled || mergeButtonDisabled}
                    icon='search' placeholder='Search...' onChange={(ee) => {
                        console.log('ee: ', ee.target.value);
                        clearTimeout(debounceOfMbolSearch);
                        setDebounceOfMbolSearch (setTimeout(() => {
                            setLocalSearchText((ee.target.value || "").trim().toUpperCase() );
                            searchForMbols((ee.target.value || "").trim(), propsForSearchForMbols, isTarget, ReconInfo).then(response => {
                                if(isTarget){
                                    setManifoldSearchResult( transformTransactionsForMerge(response.data.eventMessage) )
                                }   else{
                                    setManifoldSearchResult( response.data.eventMessage )
                                }
                            })
                        }, 300))

                    }} />
                <div className="dashedContainer" style={{ width: '100%', marginTop: '10px' }}>
                    {showSearchPane(manifoldSearchResult.shipment || [])}
                </div>
                {shipmentsClickedList.map((oneclickedShipment, iiil) => {
                if (iiil >= 10) return <></>;//TODO: Add pagination
                return <Button
                    disabled={isDisabled || mergeButtonDisabled}
                    key={"lllllxxx" + oneclickedShipment} onClick={() => {
                        setMergeErrors(null);
                        if (!window.confirm(`Unselect ${oneclickedShipment}?`)) return;
                        setShipmentsClickedList(shipmentsClickedList.filter(aaaa => aaaa != oneclickedShipment));


                    }} icon>
                    <Icon name='close' />
                    {oneclickedShipment}</Button>
            })}

            </Modal.Description>
          
        </Modal.Content>
        <Modal.Actions>

            <Button color='black' 
                onClick={() =>{
                    setSearchModalOpen(false);
                    setShipmentsClickedList([]);
                    setManifoldSearchResult("");
                    setMergeErrors(null);
                    if(mergeErrors?.warnings?.length && !mergeErrors?.errorResponse?.errors?.length){
                        document.getElementById(`card-${shipmentId}`) && document.getElementById(`card-${shipmentId}`).click();//this would be better as a api call that just reloads the bol table :/
                    }
                }}>
                    Cancel
                </Button>
            {(() => {
                let buttonIsDisabledff = !shipmentsClickedList.length || mergingGoingOn;
                return <Button
                    color={'green'}
                    content={
                        mergingGoingMessage ? mergingGoingMessage :
                            mergingGoingOn ? 'Merging...' :
                                !shipmentsClickedList.length ? 'Select BOLs' :
                                    `Merge ${shipmentsClickedList.length} BOL${shipmentsClickedList.length == 1 ? '' : 's'} to transaction ${shipmentId}`}
                    labelPosition='right'
                    disabled={isDisabled || buttonIsDisabledff}
                    icon={mergingGoingOn ?
                        <Icon name='spinner' loading /> :
                        <Icon name={buttonIsDisabledff ? 'pause' :
                            failureMergeState ? 'exclamation triangle' :
                                'checkmark'} />}
                    onClick={() => {
                        setMergeErrors(null)
                        if (mergeButtonDisabled) return;
                        if (mergingGoingOn) return ;
                        setMergeButtonDisabled(true);
                        setMergingGoingOn(true);
                        mergeshipmentMbolsToTransaction(shipmentsClickedList, shipmentId, isTarget).then(responsee => {
                            let resssult = responsee.data.eventMessage;
                            setMergingGoingOn(false)
                            console.log('resssult:x ', resssult);
                            if (resssult?.success == "true" || resssult?.data?.eventMessage?.success == "true") {
                                const hasWarnings = resssult?.warnings?.length
                                setFailureMergeState(false)
                                setMergingGoingMessage(`SUCCESS: ${resssult?.message || 'No message'}`)
                                saveDutiesNonMerchandise({
                                    "entryTypeInfo": {
                                        "entryType": entryTypeValues?.entryType || '_BLANK_'
                                    }
                                })
                                // clear states
                                setShipmentsClickedList([]);
                                if(hasWarnings){
                                    setMergeErrors(resssult);
                                }else{
                                    setTimeout(() => {
                                        document.getElementById(`card-${shipmentId}`) && document.getElementById(`card-${shipmentId}`).click();//this would be better as a api call that just reloads the bol table :/
                                    }, 2500);
                                }
                            } else {
                                setFailureMergeState(true)
                                setMergeButtonDisabled(false)
                                setMergeErrors(resssult);
                            }

                        })

                    }}

                />
            })()}
        </Modal.Actions>
    </Modal>

}

export default SearchBolsModal